import React, { useEffect, useState, useMemo } from "react";
import ApiServices from "../../services/apiServices";
import "./index.css";
import storage from "../../services/storage";
import { toast } from "react-toastify";
import { useLoad } from "../../context/Load";
import ForcaSenha from "../../Components/ForcaSenha";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useNavigate } from "react-router";
import Tabela from "../../Components/Tabela";
import { Box } from "@mui/material";
import { FaRegEdit } from "react-icons/fa";
import { BsFiletypeXlsx } from "react-icons/bs";

export default function RankingLibertadores() {
  const navigate = useNavigate();
  const { load, setLoad } = useLoad();

  // Estados para filtros
  const [tipoRanking, setTipoRanking] = useState("libertadores-final");
  const [carregandoRanking, setCarregandoRanking] = useState(false);
  const [botaoSelecionado, setBotaoSelecionado] = useState(0); // Index do botão selecionado
  const [pesquisar, setPesquisar] = useState("");
  const [listaGrupos, setListaGrupos] = useState(["Todos", "A", "B", "C", "D"]);
  const [grupoSelecionado, setGrupoSelecionado] = useState("Todos");
  // Estados para dados
  const [listarRanking, setListarRanking] = useState({
    statusCode: 200,
    itensTotal: 0,
    totalPages: 0,
    page: 1,
    pageSize: 10,
    items: [],
  });

  const [nomeArquivo, setNomeArquivo] = useState(null);
  const [filtroColuna, setFiltroColuna] = useState([]);

  const [paginacao, setPaginacao] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  // Botões de filtro
  const [botaoLibertadores, setBotaoLibertadores] = useState([
    {
      id: "1",
      nome: "Libertadores Final",
      selecionado: true,
    },
    // {
    //   id: "2",
    //   nome: "Libertadores São Paulo",
    //   selecionado: false,
    // },
    {
      id: "3",
      nome: "Quartas de Final",
      selecionado: false,
    },
  ]);

  const [colunas, setColunas] = useState([]);

  // Dados filtrados para pesquisa no front-end
  const dadosFiltrados = useMemo(() => {

    // Verificar se os dados existem e têm a estrutura correta
    const dados = listarRanking.items || listarRanking || [];

    if (!dados || dados.length === 0) {
      return [];
    }

    if (!pesquisar || pesquisar.trim() === "") {
      return dados;
    }

    const termoPesquisa = pesquisar.toLowerCase().trim();

    const filtrados = dados.filter((item) => {
      // Pesquisar por nome
      if (item.nome && item.nome.toLowerCase().includes(termoPesquisa)) {
        return true;
      }

      // Pesquisar por concessionária
      if (item.dealer && item.dealer.toLowerCase().includes(termoPesquisa)) {
        return true;
      }

      // Pesquisar por grupo
      if (item.grupo && item.grupo.toLowerCase().includes(termoPesquisa)) {
        return true;
      }

      // Pesquisar por posição
      if (item.posicao && item.posicao.toString().includes(termoPesquisa)) {
        return true;
      }

      // Pesquisar por pontuação
      if (item.pontos && item.pontos.toString().includes(termoPesquisa)) {
        return true;
      }

      return false;
    });

    return filtrados;
  }, [listarRanking, pesquisar]);

  // Dados finais para a tabela (com paginação local)
  const dadosFinais = useMemo(() => {
    const inicio = paginacao.pageIndex * paginacao.pageSize;
    const fim = inicio + paginacao.pageSize;
    const dados = dadosFiltrados.slice(inicio, fim);
    return dados;
  }, [dadosFiltrados, paginacao.pageIndex, paginacao.pageSize]);

  // Total de itens filtrados
  const totalItensFiltrados = dadosFiltrados.length;

  useEffect(() => {
    setColunas([
      {
        accessorKey: "posicao",
        header: "Posição",
        size: 70,
        muiTableHeadCellProps: { align: "left" },
        muiTableBodyCellProps: { align: "left" },
        Cell: ({ cell }) => (
          <div className="posicao-numero">{cell.getValue()}°</div>
        ),
      },
      // Corrigido: Removido o uso de função para coluna condicional, pois Material React Table espera objetos de coluna, não funções.
      // Agora, a coluna "Grupo" só é adicionada se o botão "Libertadores Final" estiver selecionado.
      ...(botaoLibertadores.find((b) => b.id === "1" && b.selecionado)
        ? [
            {
              accessorKey: "grupo",
              header: "Grupo",
              muiTableHeadCellProps: { align: "left" },
              muiTableBodyCellProps: { align: "left" },
            },
          ]
        : []),
      {
        accessorKey: "nome",
        header: "Nome",
        muiTableHeadCellProps: { align: "center" },
        muiTableBodyCellProps: { align: "center" },
        Cell: ({ cell, row }) => (
          <div className="d-flex align-items-center">
            <div className="participante-info">
              <div
                className="participante-nome"
                style={{
                  color: row.original.souEu ? "#FFD700" : "inherit",
                  fontWeight: row.original.souEu ? "bold" : "normal",
                }}
              >
                {cell.getValue()}
                {row.original.souEu && (
                  <span className="voce-indicator" style={{ color: "#FFD700" }}>
                    {" "}
                    (Você)
                  </span>
                )}
              </div>
            </div>
          </div>
        ),
      },
      {
        accessorKey: "dealer",
        header: "Concessionária",
        muiTableHeadCellProps: { align: "center" },
        muiTableBodyCellProps: { align: "center" },
      },
      {
        accessorKey: "pontos",
        header: "Pontuação",
        size: 120,
        muiTableHeadCellProps: { align: "center" },
        muiTableBodyCellProps: { align: "center" },
        Cell: ({ cell }) => (
          <div className="d-flex flex-column align-items-center">
            <div className="pontos-valor">
              {typeof cell.getValue() === "number"
                ? cell
                    .getValue()
                    .toLocaleString("pt-br", { minimumFractionDigits: 2 })
                : cell.getValue()}
            </div>
            <div
              className="pontos-label"
              style={{ fontSize: "10px", color: "#666" }}
            >
              pts
            </div>
          </div>
        ),
      },
    ]);
  }, [botaoLibertadores]);

  // Função para buscar ranking da API
  const buscarRanking = async (id) => {
    setCarregandoRanking(true);
    setListarRanking((prev) => ({ ...prev, items: [] }));

    try {
      let url = "";
      if (id == 1) {
        if (grupoSelecionado == "Todos") {
          url = "importacao/campanha-libertadores/ranking";
        } else {
          url = `importacao/campanha-libertadores/ranking?grupo=${grupoSelecionado}`;
        }
      } else if (id == 2) {
        url = "importacao/campanha-libertadores/ranking?filtro=sp";
      } else if (id == 3) {
        url = "importacao/campanha-libertadores/ranking?grupo=Z";
      }

      const response = await ApiServices.apiGet(url);

      // Verificar se a resposta tem a estrutura esperada
      if (response.data && Array.isArray(response.data)) {
        // Se a resposta é um array direto
        setListarRanking({
          statusCode: 200,
          itensTotal: response.data.length,
          totalPages: 1,
          page: 1,
          pageSize: response.data.length,
          items: response.data,
        });
      } else if (response.data && response.data.items) {
        // Se a resposta tem a estrutura com items
        setListarRanking(response.data);
      } else {
        // Fallback: tratar como array
        setListarRanking({
          statusCode: 200,
          itensTotal: response.data ? response.data.length : 0,
          totalPages: 1,
          page: 1,
          pageSize: response.data ? response.data.length : 0,
          items: response.data || [],
        });
      }
    } catch (err) {
      console.error("Erro ao buscar ranking:", err);
    } finally {
      setCarregandoRanking(false);
    }
  };

  // Função para lidar com mudança de filtro
  const handleFiltroChange = (index) => {
    setBotaoLibertadores(
      botaoLibertadores.map((botao, indexBotao) => ({
        ...botao,
        selecionado: indexBotao === index,
      }))
    );
    setBotaoSelecionado(index);

    const botaoSelecionado = botaoLibertadores[index].id;
    buscarRanking(botaoSelecionado);
    setPesquisar("");
  };

  async function fnRelatorio() {
    setLoad(true);

    // Obter o ID do botão selecionado
    const botaoSelecionado = botaoLibertadores.find(
      (botao) => botao.selecionado === true
    )?.id;

    var url = "";
    if (botaoSelecionado == 1) {
      if (grupoSelecionado == "Todos") {
        url = "importacao/campanha-libertadores/rankingxls";
      } else {
        url = `importacao/campanha-libertadores/rankingxls?grupo=${grupoSelecionado}`;
      }
    } else if (botaoSelecionado == 2) {
      url = "importacao/campanha-libertadores/rankingxls?filtro=sp";
    } else if (botaoSelecionado == 3) {
      url = "importacao/campanha-libertadores/rankingxls?grupo=Z";
    }

    try {
      let response = await ApiServices.apiDownloadXlsxGET(
        url,
        botaoSelecionado == "1"
          ? "Relatório Libertadores Final" +
              (grupoSelecionado == "Todos"
                ? " - Todos"
                : " - Grupo " + grupoSelecionado)
          : botaoSelecionado == 2
          ? "Relatório Libertadores São Paulo"
          : "Relatório Quartas de Final  "
      );
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }

  useEffect(() => {
    // Carregar ranking inicial
    const botaoSelecionado = botaoLibertadores.find(
      (botao) => botao.selecionado === true
    )?.id;
    buscarRanking(botaoSelecionado);
  }, [grupoSelecionado]);

  // Resetar paginação quando a pesquisa mudar
  useEffect(() => {
    setPaginacao((prev) => ({ ...prev, pageIndex: 0 }));
  }, [pesquisar]);

  return (
    <>
      <div className="row">
        <span className="tituloPagina">RANKING LIBERTADORES</span>

        <div className="row ">
          <div className="col-md-12 mt-3 ">
            {nomeArquivo && (
              <div className="d-flex align-items-center">
                <BsFiletypeXlsx style={{ fontSize: 30 }} />
                <div className="ms-2">{nomeArquivo}</div>
              </div>
            )}
          </div>
        </div>

        {/* Botões de filtro */}
        <div className="row d-flex align-items-end mb-3">
          {botaoLibertadores.map((grupo, index) => (
            <div className="col-md-4 col-lg-3">
              <label> </label>
              <button
                key={grupo.id}
                className={`btn ${
                  grupo.selecionado ? "btn-primary" : "btn-secondary"
                } btn-ranking-filter`}
                onClick={() => handleFiltroChange(index)}
                disabled={carregandoRanking}
              >
                {carregandoRanking && botaoLibertadores[index].selecionado ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                    >
                      <span className="visually-hidden">Carregando...</span>
                    </span>
                    Carregando...
                  </>
                ) : (
                  grupo.nome
                )}
              </button>
            </div>
          ))}
          {botaoLibertadores.find((b) => b.id === "1" && b.selecionado) && (
            <div className="col-md-4 col-lg-3">
              <label>Grupo</label>
              <select
                className="form-select"
                value={grupoSelecionado}
                onChange={(e) => setGrupoSelecionado(e.target.value)}
              >
                {listaGrupos.map((grupo) => (
                  <option key={grupo} value={grupo}>
                    {grupo}
                  </option>
                ))}
              </select>
            </div>
          )}
          <div className="col-md-4 col-lg-3">
            <label> </label>
            <button
              className="btn btn-outline-primary"
              onClick={() => {
                fnRelatorio();
              }}
            >
              Extrair relatório{" "}
              {botaoLibertadores.find((botao) => botao.selecionado === true)
                ?.nome || "Libertadores Final"}
            </button>
          </div>
        </div>

        {/* Indicador de carregamento */}
        {carregandoRanking && (
          <div className="row mt-3">
            <div className="col-md-12 text-center">
              <div className="d-flex align-items-center justify-content-center">
                <div className="spinner-border text-primary me-2" role="status">
                  <span className="visually-hidden">Carregando...</span>
                </div>
                <span>Carregando ranking...</span>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Tabela */}
      {!carregandoRanking && (
        <>
       <Tabela
            colunas={colunas}
            dados={dadosFinais}
            paginacaoPelaApi={true}
            buscaGlobal={true}
            setPesquisar={setPesquisar}
            pesquisaPelaApi={false}
            totalLinhas={totalItensFiltrados}
            setPaginacao={setPaginacao}
            paginacao={paginacao}
            filtroColuna={filtroColuna}
            setFiltroColuna={setFiltroColuna}
            buscaColunas={false}
          />
        </>
      )}
    </>
  );
}
